import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faQrcode } from "@fortawesome/free-solid-svg-icons";

import { MouseEvent } from "react";
import { Say } from "../../../languages";

type Props = {
  visible?: boolean;
  handlePhotoBoothClick: (event: MouseEvent<HTMLButtonElement>) => void;
};

const PhotoBoothButton = ({ handlePhotoBoothClick, visible = true }: Props) => {
  if (!visible) {
    return null;
  }

  return (
    <button className="photo-moderation__photo-booth-button" onClick={handlePhotoBoothClick}>
      <div className="photo-moderation__photo-booth-button__icon">
        <FontAwesomeIcon icon={faQrcode} />
      </div>
      <div className="photo-moderation__photo-booth-button__text">
        <Say phrase="photo_step.booth_cta" />
      </div>
    </button>
  );
};

export default PhotoBoothButton;
